// @ts-nocheck
import {
    PopulateApiParameter,
    FetchOrderWithLines,
    chain,
} from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import handleLinePropertiesForReorder from "@store/Framework/Common/Utilities/handleLinePropertiesForReorder";
import removeNotInCatalogLines from "@store/Framework/Common/Utilities/removeNotInCatalogLines";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, FetchOrderWithLines, props => {
    if (props.apiResult?.order.orderLines) {
        props.apiResult.order.orderLines = removeNotInCatalogLines(props.apiResult.order.orderLines);
    }
});

addToChainAfter(chain, PopulateApiParameter, props => {
    handleLinePropertiesForReorder(props.apiResult?.order.orderLines, props.apiParameter.cartLines);
});
